<template lang="pug">
.TreeBox
  .TreeSelect
    treeselect(
      ref="treeselect",
      :value="value",
      :disabled="disabled",
      :clearable="clearable",
      :clearOnSelect="true",
      :options="options",
      :multiple="multiple",
      :disable-branch-nodes="true",
      @input="(node) => updateValue(node)",
      :defaultExpandLevel="Infinity",
      :placeholder="placeholder"
    )
      div(slot="value-label", slot-scope="{ node }") {{ node.raw.label }}
      div(slot="option-label", slot-scope="{ node }")
        input(
          v-if="!multiple && radio",
          type="radio",
          :id="node.raw.label",
          :name="node.raw.label",
          :value="value",
          :checked="node.raw.label === value"
        )
        label
          | {{ node.raw.label }}
  span.text-field__error.has-text-danger(v-if="error")
    | {{ error }}
</template>

<script>
  import Treeselect from '@riophae/vue-treeselect';
  import '@riophae/vue-treeselect/dist/vue-treeselect.css';

  export default {
    name: 'TreeSelect',
    components: {
      Treeselect,
    },

    data() {
      return {
        options: null,
        labels: false,
        arrayData: [],
      };
    },
    created() {
      this.mapData();
    },
    watch: {
      arrData(data) {
        this.arrayData = data;
        this.mapData();
      },
    },
    methods: {
      updateValue(value) {
        this.$emit('updateValue', value);
      },
      mapData() {
        if (this.arrData) {
          this.options = this.arrData.map(i => ({
            id: i,
            label: i,
          }));
        }
      },
    },
    props: {
      multiple: {
        type: Boolean,
        default: false,
      },
      placeholder: {
        type: String,
        default: null,
      },
      value: {
        type: [String, Array],
        default: null,
      },
      arrData: {
        type: Array,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      clearable: {
        type: Boolean,
        default: false,
      },
      radio: {
        type: Boolean,
        default: false,
      },
      error: String,
    },
  };
</script>

<style lang="scss" scoped>
.TreeBox {
  display: flex;
  width: 288px;
  flex-direction: column;
  position: relative;
  span {
    position: absolute;
    bottom: -7px;
    font-size: 14px;
    left: 15px;
  }
  @media (max-width: 996px) {
    width: 100%;
  }
}
.TreeSelect {
  cursor: pointer;
}
.selectDropDown {
  width: 100%;
}
.disabled {
  cursor: not-allowed;
  .vue-treeselect {
    pointer-events: none;
  }
}
input[type="radio"] {
  -webkit-appearance: none;
  width: 20px;
  height: 20px;
  border: 1px solid #03dac4;
  border-radius: 50%;
  outline: none;
  vertical-align: middle;
  margin-right: 10px;
  margin-left: 12px;
}
input[type="radio"]:hover {
  box-shadow: 0 0 5px 0px #03dac4 inset;
}
input[type="radio"]:before {
  content: "";
  display: block;
  width: 60%;
  height: 60%;
  margin: 20% auto;
  border-radius: 50%;
}
input[type="radio"]:checked:before {
  background: #03dac4;
}
</style>
